<template>
    <div v-if="!data.length" class="no-data-container">{{$t('empty_list')}}</div>
    <ul v-else class="tree-view-component">
        <template v-for="item in data">
            <TreeItem
                :key="item.id"
                class="tree-item"
                :item="item"
                :item-children="itemChildren"
                :item-is-expanded="itemIsExpanded"
                :item-is-active="itemIsActive"
            >
                <template scope="_">
                    <slot :item="_.item"/>
                </template>
            </TreeItem>
        </template>
    </ul>
</template>

<script lang="ts">
import TreeItem from "./TreeItem.vue";
import Component from 'vue-class-component';
import Vue from 'vue';

export interface ITreeItemAction {
    id: number,
    icon: string,
    text: string,
    isVisible: (item: any) => boolean,
    isActive: (item: any) => boolean,
    itemClicked: (item: any) => void,
}

@Component({
    components: { TreeItem },
    props: {
        data: { type: Array, required: true },
        itemChildren: { type: Function, required: false },
        itemIsExpanded: { type: Function, required: false },
        itemIsActive: { type: Function, required: false },
    },
})
class TreeView extends Vue {}

export default TreeView;
</script>

<style scoped>

    .no-data-container {
        padding: 0 0.5em;
    }

    .tree-view-component {
        list-style: none;
        padding: 0;
        margin: 0;
    }

</style>